import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadProductOnboardingForms = createAction('[StaticData] Load OnboardingForms');

export const loadProductOnboardingFormsSuccess = createAction(
  '[StaticData] Load OnboardingForms Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductOnboardingFormsFailure = createAction('[StaticData] Load OnboardingForms Failure', props<{ error: any }>());
